import { ArrowRight } from "@mui/icons-material";
import { Avatar, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import Loader from "../../../components/shared/SuspenseFallback";
import {
  setDisplayChatAction,
  setDisplayCustomerDataAction,
  setSelectedConversationAction,
} from "../../../redux/users/actions";
import MessageItem from "../../Messages/Chat/MessageItem";

const useStyles = makeStyles((theme) => ({
  root: {
    borderLeft: "1px solid rgb(0,0,0,.1)",
    width: "100% !important",
    padding: 0,
    margin: 0,
    backgroundColor: theme.palette.bg,
  },
  arrow: {
    color: theme.palette.primary.main,
  },
  title: {
    color: "white",
    display: "flex",
    justifyContent: "flex-start",
    backgroundColor: theme.palette.primary.main,
  },
  backButton: {
    padding: "1%",
    marginTop: "3%",
    color: "white",
    "&:hover": {
      cursor: "pointer",
    },
  },
  messages: {
    padding: "4%",
    width: "100%",
    backgroundColor: theme.palette.bg,
  },
  loader: {
    textAlign: "center",
  },
  noStarredMessages: {
    textAlign: "center",
    color: theme.palette.secondary.main,
  },
  username: {
    padding: 0,
    margin: 0,
    marginBottom: "1%",
    fontFamily: "SFProText-Semibold",
    fontSize: "16px",
    display: "flex",
  },
  avatarDiv: {
    marginRight: "12px",
  },
  avatar: {
    width: "43px",
    height: "43px",
    fontSize: "14px",
  },
  hr: {
    backgroundColor: "rgb(0,0,0,.1)",
    width: "97%",
    height: "1px",
    border: 0,
    display: "block",
    marginBottom: "6px",
  },
}));

function StarredMessages() {
  const navigate = useNavigate();
  const [starredMessages, setStarredMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    userInfo: { token, _id: userId },
  } = useSelector((state) => state.user);

  useEffect(() => {
    const getStarredMessages = async () => {
      const {
        data: {
          data: { messages },
        },
      } = await axios.get(`/api/v1/messages?star=true`, {
        headers: {
          Authorization: token,
        },
      });
      setLoading(false);
      setStarredMessages(messages);
    };
    getStarredMessages();
  }, []);

  const handleMessageClick = async (_id, conversation_id) => {
    setLoading(true);
    const {
      data: { data: conversation },
    } = await axios.get(`/api/v1/conversations/${conversation_id}?specific_conversation=true`, {
      headers: {
        Authorization: token,
      },
    });
    dispatch(setSelectedConversationAction({ ...conversation.conversation[0], msgIdStore: _id }));
    dispatch(setDisplayChatAction(true));
    dispatch(setDisplayCustomerDataAction(true));
    setLoading(false);
    navigate("/messages");
  };

  return (
    <Grid item={true} className={classes.root}>
      {loading && (
        <div className={classes.loader}>
          <Loader from />
        </div>
      )}

      <div className={classes.messages}>
        {starredMessages && starredMessages.length ? (
          starredMessages.map(
            ({
              _id,
              body,
              date,
              type,
              id,
              from: { _id: msgUserId, avatar_url, first_name, last_name },
              conversation_id,
            }) => {
              const to = conversation_id?.members.find((user) => user && user._id !== msgUserId);

              return (
                <div key={_id}>
                  <div
                    style={{ display: "flex" }}
                    onClick={() => handleMessageClick(_id, conversation_id._id)}
                  >
                    {/* Avatar */}
                    <div className={classes.avatarDiv}>
                      <Avatar
                        src={avatar_url || null}
                        style={{
                          backgroundColor: avatar_url ? null : "#bababa",
                        }}
                        classes={{ root: classes.avatar }}
                      >
                        {avatar_url
                          ? null
                          : `${first_name && first_name[0]}${last_name && last_name[0]}`}
                      </Avatar>
                    </div>

                    {/* Message and user sender name */}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <p className={classes.username}>
                        {msgUserId === userId ? "You" : `${first_name} ${last_name}`}

                        <ArrowRight className={classes.arrow} />
                        {to?._id === userId ? "You" : `${to?.first_name} ${to?.last_name}`}
                      </p>
                      <MessageItem
                        starredMessage={true}
                        date={date}
                        body={body}
                        type={type}
                        from={[{ _id: msgUserId }]}
                        id={id}
                      />
                    </div>
                  </div>
                  <hr className={classes.hr} />
                </div>
              );
            },
          )
        ) : (
          <p className={classes.noStarredMessages}>You don't have starred messages</p>
        )}
      </div>
    </Grid>
  );
}

export default StarredMessages;
